import { takeLatest } from "redux-saga/effects";

import { defaultReturn, makePayload, generateDefaultActions, subKeySaga } from "../utils/helpers";

const getGuestCompanyId = () => localStorage.getItem("guestCompanyId");
export const GET_PORTFOLIO_METRICS = generateDefaultActions("GET_PORTFOLIO_METRICS");
export const getPortfolioMetrics = payload => makePayload(GET_PORTFOLIO_METRICS.value, payload);
function* getPortfolioMetricsSaga(payload) {
  const guestCompanyId = getGuestCompanyId();
  let url = "/metrics/portfolio";
  if (payload.companyId) {
    url = `${url}/${payload.companyId}`;
  }
  if (guestCompanyId) {
    url = `/metrics/portfolio/${guestCompanyId}`;
  }

  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(GET_PORTFOLIO_METRICS, url, "GET");
}

const initialState = {
  metricData: []
};

export function newPortfolioReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_PORTFOLIO_METRICS.success:
      return defaultReturn(state, payload.data, "metricData");

    default:
      return state;
  }
}

export function* newPortfolioSaga() {
  yield takeLatest(GET_PORTFOLIO_METRICS.value, getPortfolioMetricsSaga);
}
